import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';

import ErrorBoundary from 'components/ErrorBoundary';
import GenericError from 'components/GenericError';
import Layout from 'components/Layout';
import HeadWithNoIndexAndNoFollow from 'components/Seo/HeadWithNoIndexAndNoFollow';

import placeholder from 'lib/placeholder';

import LastCommentsHeading from './Heading';
import LastCommentsList from './List';
import LastCommentsSidebar from './Sidebar';
import LastCommentsTabNav from './TabNav';

const LastCommentsPage = ({
  commentsSource,
  commentsPage = null,
  sidebarFeaturedOffers = [],
}) => (
  <>
    <HeadWithNoIndexAndNoFollow
      description={placeholder('seo.lastComments.description')}
    />
    <Layout
      headingComponent={<LastCommentsHeading />}
      sidebarComponent={
        <LastCommentsSidebar
          commentsSourceName={commentsSource.name}
          sidebarFeaturedOffers={sidebarFeaturedOffers}
        />
      }
      maxWidthOnMobileDevices
    >
      <Box className="xl:mb-16" full>
        <LastCommentsTabNav commentsSource={commentsSource} />
        <ErrorBoundary
          fallback={
            <GenericError
              message={placeholder('errors.couldNotLoadLastComments')}
            />
          }
        >
          <LastCommentsList
            commentsPage={commentsPage}
            commentsSource={commentsSource}
          />
        </ErrorBoundary>
      </Box>
    </Layout>
  </>
);

LastCommentsPage.propTypes = {
  commentsSource: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string,
  }).isRequired,
  commentsPage: PropTypes.number,
  sidebarFeaturedOffers: PropTypes.arrayOf(
    PropTypes.shape({
      offerId: PropTypes.number.isRequired,
      offerTitle: PropTypes.string.isRequired,
      offerPrice: PropTypes.number.isRequired,
      offerOldPrice: PropTypes.number,
      offerPriceType: PropTypes.string.isRequired,
      offerPhoto: PropTypes.string.isRequired,
      offerSlug: PropTypes.string.isRequired,
    })
  ),
};

export default LastCommentsPage;
